import { useState } from "react";
import type { Opportunity } from "@/types/opportunity";
import { useDualReadProductTypes } from "@/hooks/useDualReadProductTypes";
import { createOpportunityFollowOnDeal } from "@/lib/opportunity/opportunityFollowOnClient";
import { opportunityFulfillmentIsLocked } from "@/lib/opportunity/instanceFulfillment";

export function OpportunityFollowOnDealField(props: {
  opportunity: Opportunity;
  disabled?: boolean;
  setMessage: (msg: { text: string; ok: boolean } | null) => void;
}) {
  const { opportunity, disabled, setMessage } = props;
  const catalog = useDualReadProductTypes();
  const followOn = catalog.some((p) => p.tag === opportunity.product_type && p.followOn === true);
  const locked = opportunityFulfillmentIsLocked(opportunity.status);
  const [busy, setBusy] = useState(false);
  const [dealId, setDealId] = useState<string | null>(null);

  if (!followOn) return null;

  async function openDeal() {
    setBusy(true);
    setMessage(null);
    const r = await createOpportunityFollowOnDeal({ opportunity_id: opportunity.id });
    setBusy(false);
    if (!r.ok) {
      setMessage({ text: r.error, ok: false });
      return;
    }
    setDealId(r.data.deal_id);
    setMessage({
      text: r.data.existing
        ? `Follow-on deal already open: ${r.data.deal_id.slice(0, 8)}… Original sale pointer unchanged.`
        : `Opened follow-on deal ${r.data.deal_id.slice(0, 8)}… Original sale pointer unchanged.`,
      ok: true,
    });
  }

  return (
    <div className="space-y-1 pl-[6.5rem]">
      <p className="text-xs text-gray-500 dark:text-zinc-400">
        Follow-on product — a separate deal on the same serial. Does not replace the original sale.
      </p>
      <button
        type="button"
        disabled={disabled || busy || locked || !opportunity.mfg_unit_id}
        onClick={() => void openDeal()}
        className="rounded-md border border-gray-300 px-3 py-1 text-xs dark:border-zinc-600"
      >
        {busy ? "Opening…" : dealId ? "Follow-on deal attached" : "Open follow-on deal on this serial"}
      </button>
      {!opportunity.mfg_unit_id ? (
        <p className="text-xs text-gray-400">Attach a lot serial first.</p>
      ) : null}
    </div>
  );
}
